import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { getTextColorsFromSection } from '../lib/colors';
import Section from '../Section';
import StoreButton from './StoreButton';
import TypographyDraft from '../TypographyDraft';

function getStoreButtons(data, classes) {
  return (
    <div className={classes.storeButtonsWrapper}>
      {data.googlePlayLink && <StoreButton brand="google" link={data.googlePlayLink} />}
      {data.appStoreLink && <StoreButton brand="apple" link={data.appStoreLink} />}
    </div>
  );
}

function AppSection({ classes, event, site, section }) {
  const { data, styles } = section;
  const colors = getTextColorsFromSection(site, section);

  return (
    <Section
      site={site}
      section={section}
      className={classNames(
        classes.root,
        !data.image && classes.noImage,
        !data.description && classes.noDescription,
      )}
    >
      <div className={classes.content}>
        {data.title && (
          <TypographyDraft
            component="h2"
            style={{ ...colors.title, ...styles.title }}
            data={data.title}
            paragraph
          />
        )}
        {data.description && (
          <TypographyDraft
            style={{ ...colors.text, ...styles.description }}
            data={data.description}
          />
        )}
        {data.image && getStoreButtons(data, classes)}
      </div>
      {data.image ? (
        <div
          className={data.description ? classes.imageWrapper : classes.imageWrapperNoDescription}
        >
          <img alt="" className={classes.image} src={data.image.url} />
        </div>
      ) : (
        getStoreButtons(data, classes)
      )}
    </Section>
  );
}

AppSection.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    padding: [theme.spacing.xlarge, theme.spacing.large],
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
      padding: [theme.spacing.large, theme.spacing.medium],
    },
  },
  noImage: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  noDescription: {
    [theme.breakpoints.down('xl')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
      textAlign: 'center',
      padding: [theme.spacing.large, theme.spacing.medium],
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: 70 * theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'center',
    },
  },
  storeButtonsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 3 * theme.spacing.unit,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: theme.spacing.large,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginBottom: theme.spacing.large,
    },
  },
  imageWrapperNoDescription: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 0,
    marginBottom: theme.spacing.large,
  },
  image: {
    width: 400,
    [theme.breakpoints.down('md')]: {
      width: 300,
    },
  },
});

export default injectSheet(stylesheet)(AppSection);



// WEBPACK FOOTER //
// ./src/site-render/src/AppSection/AppSection.js